import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { BasicInfoArea, ClmtoInfo, SuppntInfo } from 'sg-api';

@Component({
  selector: 'app-sgke360d-customer-info',
  templateUrl: './sgke360d-customer-info.component.html',
  styleUrl: './sgke360d-customer-info.component.scss'
})
export class Sgke360dCustomerInfoComponent implements OnInit, OnDestroy {

  /** 初期表示APIのレスポンス */
  @Input() basicInfoArea: BasicInfoArea;

  /** 供給地点情報 */
  suppntInfo: SuppntInfo;
  /** 請求先情報 */
  clmtoInfo: ClmtoInfo;
  /** 使用者名 */
  get siyoushamei(): string {
    return `${this.suppntInfo.userMeiKanji}（${this.suppntInfo.userMeiKana}）`;
  }
  /** 請求先名 */
  get seikyusakimei(): string {
    // "請求先名カナ"がある場合はカナも表示する
    if (this.clmtoInfo.clmtoMeiKana) {
      return `${this.clmtoInfo.clmtoMeiKanji}（${this.clmtoInfo.clmtoMeiKana}）`;
    } else {
      return `${this.clmtoInfo.clmtoMeiKanji}`;
    }
  }

  /**
   *コンストラクタ
   * @memberof Sgke360dCustomerInfoComponent
   */
  constructor() { }

  // 初期化処理
  ngOnInit(): void {
    // 供給地点情報
    this.suppntInfo = this.basicInfoArea.suppntInfo;
    // 請求先情報
    this.clmtoInfo = this.basicInfoArea.clmtoInfo;
  }
  /**
   * 終了処理
   *
   * @memberof Sgke360dCustomerInfoComponent
   */
  ngOnDestroy(): void {
  }
}
